import { render, staticRenderFns } from "./ListSimple.vue?vue&type=template&id=4327e514&"
import script from "./ListSimple.vue?vue&type=script&lang=js&"
export * from "./ListSimple.vue?vue&type=script&lang=js&"
import style0 from "./ListSimple.vue?vue&type=style&index=0&id=4327e514&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports